const header = "_7chvxucb7";
const context = "_7cc1d3auwu";

export { context, header };
import "./pm2.header.style.linaria.module.css";
//# sourceMappingURL=pm2.header.style.js.map
